module.exports = __webpack_public_path__ + "static/meta/sqs/2021/layout_metadata.5cbaffb.tsv";


//////////////////
// WEBPACK FOOTER
// ./src/components/sqs/2021/meta/layout_metadata.tsv
// module id = RdSd
// module chunks = 0